import React from 'react'
import styled, { css } from 'styled-components'
import Button, { AnchorButton } from 'components/Button'
import { ButtonWrapper } from 'components/Button/Button.styles'
import { Flex } from 'components/Box'
import { ReactComponent as OpenInSketchSVG } from 'icons/square.arrow.up.right-20.svg'
import { ReactComponent as ExportAssetsSVG } from 'icons/download-asset-20.svg'
import { ReactComponent as AddLibrarySVG } from 'icons/link-library-20-wide.svg'
import { ReactComponent as DownloadDocumentSVG } from 'icons/download-document-20.svg'
import { dropdownDividerStyles } from 'components/Dropdown'

const ICON_SIZE = {
  width: 20,
  height: 20,
}

const iconStyles = css`
  color: ${({ theme }) => theme.colors.gray};
`

const OpenInSketchIcon = styled(OpenInSketchSVG).attrs(ICON_SIZE)`
  ${iconStyles}
`

const AddLibraryIcon = styled(AddLibrarySVG).attrs(ICON_SIZE)`
  ${iconStyles}
`

const ExportAssetsIcon = styled(ExportAssetsSVG).attrs(ICON_SIZE)`
  ${iconStyles}
`

const DownloadDocumentIcon = styled(DownloadDocumentSVG).attrs(ICON_SIZE)`
  ${iconStyles}
`

const Error = styled.div`
  &::before {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.red};
    opacity: 0.05;
  }
  position: relative;
  color: ${({ theme }) => theme.colors.red};
  margin-top: 12px;
  padding: 12px;
  text-align: center;
  font-size: 0.8125rem;
`

const ByteCount = styled.span`
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
`

const ButtonWithIconWrapper: React.FC = ({ children }) => (
  <Flex flex="1" justifyContent="space-between" alignItems="center">
    {children}
  </Flex>
)

const sidebarButtonStyle = css`
  /* any element + button, or button + any element that contains a button => margin top */
  * + & {
    margin-top: 16px;
  }

  & + &,
  & + a {
    margin-left: 0;
  }
`

const DownloadSectionItem = styled.div`
  &:not(:first-child) {
    margin-top: 16px;
  }
`

const SidebarButton = styled(Button)`
  ${sidebarButtonStyle}
`

const SidebarAnchor = styled(AnchorButton)`
  ${sidebarButtonStyle}

  & + * ${SidebarButton} {
    margin-top: 16px;
  }

  ${ButtonWrapper} {
    justify-content: space-between;
    display: flex;
    width: 100%;
  }
  justify-content: space-between;
  display: flex;
  width: 100%;
`

SidebarButton.defaultProps = {
  small: true,
  fill: true,
  contentWrapper: ButtonWithIconWrapper,
}

const Divider = styled.div`
  ${dropdownDividerStyles};
  margin: 16px 0 0;
`

export {
  AddLibraryIcon,
  ByteCount,
  Divider,
  DownloadDocumentIcon,
  Error,
  ExportAssetsIcon,
  OpenInSketchIcon,
  SidebarButton,
  SidebarAnchor,
  DownloadSectionItem,
}
